import React, { useEffect, useState } from "react";
import '../style/loan-disbursement.css';
import {
    API_CENTERS, API_GET_CLIENTS, API_ADD_LOAN_DISBURSE, API_GET_LOANS
} from '../Config/ApiUrlConstant'; // Import your constants
import { useAuth } from '../AuthContext'; // Import useAuth hook for access

const branches = [
    {
        "id": 1,
        "branch_no": "BRAN0001",
        "branch_name": "Mohanw"
    }
];

const employeeList = [
    {
        "id": 1,
        "emp_generate_id": "EMP0001",
        "emp_name": "Awadhesh Kumar",
        "emp_role": "1" // BM
    },
    {
        "id": 2,
        "emp_generate_id": "EMP0002",
        "emp_name": "Manohar Prasad",
        "emp_role": "2" // STAFF
    },
];
const LoanDisbursement = () => {
    const [formData, setFormData] = useState({
        branch_id: "",
        center_id: "",
        client_id: "",
        date_of_disbursement: "",
        date_of_repayment: "",
        disbursed_by_bm: "",
        disbursed_by_staff: "",
        disbursed_amt: "",
        demand_loan_id: '',
        approve_loan_id: '',
        demand_loan_amt: '',
        approve_loan_amt: '',
        is_closed_loan: 0,
    });
    const [clients, setClients] = useState([]);
    const [centerList, setCenterList] = useState([]);
    const [allLoans, setAllLoans] = useState([]);
    const { logout } = useAuth(); // Add this at the top inside the component
    const token = localStorage.getItem('token');
    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log('e.target->', value)
        // if (name == "client_id") {
        //     const findData = clients.find(client => client.id == value);
        //     console.log('findData->', findData)
        //     if (findData) {
        //         setFormData({
        //             ...formData,
        //             disbursed_amt: parseInt(findData.approve_loan_amt),
        //             client_id: findData.id,
        //             remaining_principal_amt: parseInt(findData.approve_loan_amt)
        //         });
        //     }

        // } else {
            if (name == 'branch_id' && value != "") {
                getCentersByBranch(value);
            } else if (name == 'branch_id' && value == "") {
                setCenterList([])
                setClients([])
            }
            setFormData({
                ...formData,
                [name]: value,
            });
        // }
    };

    const getCentersByBranch = async (branchId) => {
        try {
            const response = await fetch(API_CENTERS, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',  // Add Content-Type header
                    'Authorization': `Bearer ${token}`,  // ✅ Send token in Authorization header
                },
                // body: JSON.stringify({ is_all: true })  // Serialize the body to JSON
                body: JSON.stringify({ is_all: false, branch_id: branchId })  // Serialize the body to JSON
            });
            if (response.status === 401 || response.status === 403) {
                logout(); // 👈 Token invalid or expired → logout
                return;
            }
            const responseData = await response.json(); // Parse JSON response
            console.log('responseData ->', responseData)
            setCenterList(responseData.data)
        } catch (error) {
            console.error('Error:', error);
            setCenterList([])
        }
    }
    const getClients = async (centerId) => {
        if (centerId) {
            try {
                const response = await fetch(API_GET_CLIENTS, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',  // Add Content-Type header
                        'Authorization': `Bearer ${token}`,  // ✅ Send token in Authorization header
                    },
                    body: JSON.stringify({
                        center_id: centerId, is_all: true
                    }),
                });
                if (response.status === 401 || response.status === 403) {
                    logout(); // 👈 Token invalid or expired → logout
                    return;
                }
                const result = await response.json();

                setClients(result.data);
            } catch (error) {
                alert("An error occurred. Please try again.");
                console.error(error);
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(API_ADD_LOAN_DISBURSE, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',  // Add Content-Type header
                    'Authorization': `Bearer ${token}`,  // ✅ Send token in Authorization header
                },
                body: JSON.stringify(formData),
            });
            if (response.status === 401 || response.status === 403) {
                logout(); // 👈 Token invalid or expired → logout
                return;
            }
            const result = await response.json();
            if (result.loanDisburseId > 0) {
                resetForm();
                alert("Loan disbursement details submitted successfully.");
            } else {
                alert("Failed to submit loan disbursement details.");
            }
        } catch (error) {
            alert("An error occurred. Please try again.");
            console.error(error);
        }
    };

    const resetForm = () => {
        setFormData({
            branch_id: "",
            center_id: "",
            client_id: "",
            date_of_disbursement: "",
            date_of_repayment: "",
            disbursed_by_bm: "",
            disbursed_by_staff: "",
            disbursed_amt: "",
            demand_loan_amt: '',
            demand_loan_id: '',
            approve_loan_id: '',
            approve_loan_amt: '',
            is_closed_loan: 0,
        });
    };
    // const getApproveLoan = async () => {
    //     formData['is_all'] = false;
    //     try {
    //         const response = await fetch(API_GET_LOANS, {
    //             method: "POST",
    //             headers: {
    //                 'Content-Type': 'application/json',  // Add Content-Type header
    //                 'Authorization': `Bearer ${token}`,  // ✅ Send token in Authorization header
    //             },
    //             body: JSON.stringify(formData),
    //         });
    //         if (response.status === 401 || response.status === 403) {
    //             logout(); // 👈 Token invalid or expired → logout
    //             return;
    //         }
    //         const result = await response.json();
    //         console.log('result get loan detail ->', result.data)
    //         setFormData({
    //             ...formData,
    //             disbursed_amt: result.data.loan_amt
    //         }
    //         )
    //     } catch (error) {
    //         console.error(error);
    //     }
    // }

    const getAllLoans = async () => {
        formData['is_all'] = true;
        try {
            const response = await fetch(API_GET_LOANS, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',  // Add Content-Type header
                    'Authorization': `Bearer ${token}`,  // ✅ Send token in Authorization header
                },
                body: JSON.stringify(formData),
            });
            if (response.status === 401 || response.status === 403) {
                logout(); // 👈 Token invalid or expired → logout
                return;
            }
            const result = await response.json();
            console.log('result get loan detail ->', result.data)
            setAllLoans(result.data);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getClients(formData.center_id);
    }, [formData.center_id]);

    useEffect(() => {
        // getApproveLoan();
        getAllLoans();
    }, [formData.client_id])

    return (
        <div className="form-container">
            <h2>Loan Disbursement Form</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Branch Name</label>
                    <select
                        className="form-control"
                        name="branch_id"
                        value={formData.branch_id}
                        onChange={handleChange}
                        required
                    >
                        <option value="" >Select Branch</option>
                        {branches.map(branch => (
                            <option key={branch.id} value={branch.id}>
                                {branch.branch_name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label>Center Name</label>
                    <select
                        className="form-control"
                        name="center_id"
                        value={formData.center_id}
                        onChange={handleChange}
                        required
                    >
                        <option value="" >Select Center</option>
                        {centerList.map(center => (
                            <option key={center.id} value={center.id}>
                                {center.center_name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label>Client Name</label>
                    <select
                        className="form-control"
                        name="client_id"
                        value={formData.client_id}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select Client</option>
                        {clients.map(client => (
                            <option key={client.id} value={client.id}>
                                {client.client_name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <label>Date of Disbursement</label>
                    <input
                        type="date"
                        name="date_of_disbursement"
                        value={formData.date_of_disbursement}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="form-group">
                    <label>Date of Repayment</label>
                    <input
                        type="date"
                        name="date_of_repayment"
                        value={formData.date_of_repayment}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>Disbursed By BM</label>
                    <select
                        className="form-control"
                        name="disbursed_by_bm"
                        value={formData.disbursed_by_bm}
                        onChange={handleChange}
                        required
                    >
                        <option value="" disabled>Select Branch Manager</option>
                        {employeeList.map(employee => {
                            if (employee.emp_role == '1')
                                return (
                                    <option key={employee.id} value={employee.id}>
                                        {employee.emp_generate_id}
                                    </option>
                                )
                        })}
                    </select>
                </div>

                <div className="form-group">
                    <label>Disbursed By Staff</label>
                    <select
                        className="form-control"
                        name="disbursed_by_staff"
                        value={formData.disbursed_by_staff}
                        onChange={handleChange}
                        required
                    >
                        <option value="" disabled>Select Staff</option>
                        {employeeList.map(employee => {
                            if (employee.emp_role == '2') {
                                return (
                                    <option key={employee.id} value={employee.id}>
                                        {employee.emp_generate_id}
                                    </option>
                                )
                            }

                        })}
                    </select>
                </div>

                <div className="form-group">
                    <label>Demand Loan Amount *</label>
                    <select
                        className="form-control"
                        name="demand_loan_id"
                        value={formData.demand_loan_id}
                        onChange={handleChange}
                        required
                    >
                        <option value="" >Select Demand Loan</option>
                        {allLoans.map(loan => (
                            <option key={loan.id} value={loan.id}>
                                {loan.loan_amt}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label>Approved Loan Amount *</label>
                    <select
                        className="form-control"
                        name="approve_loan_id"
                        value={formData.approve_loan_id}
                        onChange={handleChange}
                        required
                    >
                        <option value="" >Select Approve Loan</option>
                        {allLoans.map(loan => (
                            <option key={loan.id} value={loan.id}>
                                {loan.loan_amt}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <button type="submit">Submit</button>
                </div>
            </form>
        </div>
    );
};

export default LoanDisbursement;